import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: 'input,input[formcontrolname],input[formcontrol],textarea,textarea[formcontrolname],[formControlName],[formControl]'
})
export class GlobalInputValidationDirective {

  @HostListener('keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    // Define the characters you want to block
    const forbiddenChars = ['<', '>', '{', '}', '[', ']', '=',  ';' ];
    // Get the pressed key
    const pressedKey = event.key;
    // Check if the pressed key is one of the forbidden characters
    if (forbiddenChars.includes(pressedKey) && event?.target['id'] !='allowTagSymbolRef') {
      // Prevent the default behavior (character entry)
      event.preventDefault();
    }
  }
  @HostListener('paste', ['$event']) 
  onPaste(event: ClipboardEvent) {
    // Get the pasted value from the clipboard
    const pastedValue = event.clipboardData?.getData('text') || '';
    // Define the restricted characters
    const restrictedCharacters = ['<', '>', '{', '}', '[', ']', '=', ':', ';'];
    // Check if the pasted value contains any restricted character
    if (restrictedCharacters.some(char => pastedValue.includes(char))) {
      // Prevent the paste operation
      event.preventDefault();
    }
  }
}